/** @format */

import React from 'react'
import { useGA4React } from 'ga-4-react'

import './style.css'

export function SuccessView(props) {
  const ga = useGA4React()

  const shopNow = () => {
    window.open('https://vuse.co.nz/')
    ga.event('shop_now_click', 'Flavour Drop')
  }

  return (
    <div className="submit-ended">
      <div className="content">
        <div className="title">{props.title}</div>
        <div className="text">{props.message}</div>

        <button className="btn btn-primary" onClick={() => shopNow()}>
          <span className="btn-label">Shop Now</span>
        </button>
        <button className="btn" onClick={props.onPress}>
          <span className="btn-label">Play Again</span>
        </button>
      </div>
    </div>
  )
}

export default SuccessView
